import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./UpcomingEvents.css";

import dateIcon from "./assets/svg/date.svg";
import locationIcon from "./assets/svg/location.svg";
import arrowIcon from "./assets/svg/arrow.svg";
import defaultImage from "./assets/image.png";

const isFutureEvent = (event) => {
  const raw = event.acf?.event_date;
  if (!raw) return true;
  const normalized = raw.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
  const eventDate = new Date(normalized);
  if (isNaN(eventDate)) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return eventDate >= today;
};

const UpcomingEvents = ({ featuredSlug }) => {
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const location = useLocation();
  const isEventDetailsPage = location.pathname.startsWith("/events/");

  useEffect(() => {
    fetch("https://beszeljegyesulet.hu/wp/wp-json/wp/v2/events")
      .then((res) => res.json())
      .then((data) => {
        const future = data.filter(isFutureEvent);
        // Exclude the featured event by slug
        const filtered = featuredSlug
          ? future.filter((e) => e.slug !== featuredSlug)
          : future;
        setEvents(filtered);
        setLoaded(true);
      })
      .catch((err) => {
        console.error("Hiba az események betöltésekor:", err);
        setLoaded(true);
      });
  }, [featuredSlug]);

  const formatEventDate = (rawDate) => {
    if (!rawDate) return "Dátum nem elérhető";
    const normalized = rawDate.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
    const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return rawDate;
    const [_, year, month, day] = match;
    const dateObj = new Date(year, month - 1, day);
    const formatted = dateObj.toLocaleDateString("hu-HU", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return formatted.charAt(0).toLowerCase() + formatted.slice(1);
  };

  // Don't render anything until loaded
  if (!loaded) return null;

  // If no events after filtering, render nothing (no heading either)
  if (events.length === 0) return null;

  return (
    <section className="upcoming-events">
      {!isEventDetailsPage && (
        <h2 className="title-sm">Közelgő eseményeink</h2>
      )}
      <div className="events-grid">
        {events.map((event) => {
          const featured = event.featured_image_url || defaultImage;
          const formattedDate = formatEventDate(event.acf?.event_date);

          return (
            <div className="event-card" key={event.id}>
              <div className="event-image-wrap">
                <div
                  className="event-image-blur"
                  style={{ backgroundImage: `url(${featured})` }}
                  aria-hidden="true"
                />
                <img
                  src={featured}
                  alt={event.title.rendered}
                  className="event-image"
                />
              </div>

              <div className="upcomingevent-content">
                <div className="event-meta">
                  {event.acf?.event_date && (
                    <div className="meta-item">
                      <div className="icon">
                        <img src={dateIcon} alt="date" />
                      </div>
                      <span><b>{formattedDate}</b></span>
                    </div>
                  )}
                  {event.acf?.event_location && (
                    <div className="meta-item">
                      <div className="icon">
                        <img src={locationIcon} alt="location" />
                      </div>
                      <span><b>{event.acf.event_location}</b></span>
                    </div>
                  )}
                </div>

                <h3
                  className="heading-sm"
                  dangerouslySetInnerHTML={{ __html: event.title.rendered }}
                />

                <p
                  className="body-sm"
                  dangerouslySetInnerHTML={{
                    __html:
                      event.excerpt?.rendered
                        ?.replace(/<[^>]+>/g, "")
                        ?.substring(0, 160) + "...",
                  }}
                />

                <div className="event-buttons">
                  <Link to={`/events/${event.slug}`} className="event-link">
                    Részletek{" "}
                    <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" />
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default UpcomingEvents;